import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe269346"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opacity-0 fade-in-delay" }
const _hoisted_2 = { class: "flex flex-col justify-center px-4 h-20 border-b border-gray-800" }
const _hoisted_3 = { class: "grid mt-2 text-lg grid-col-1" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "grid mt-5 text-sm grid-col-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "px-4 pb-1 font-medium text-secondary" }, "Ecosystem", -1))
const _hoisted_7 = { class: "px-4 mt-6" }
const _hoisted_8 = { class: "grid grid-rows-1 grid-flow-col auto-cols-min gap-2 px-4 mt-4" }
const _hoisted_9 = { class: "px-4 mt-6 text-xs" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = { class: "ml-2 text-gray-300" }

import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import AppLogo from '@/components/images/AppLogo.vue';
import useApp from '@/composables/useApp';
import useConfig from '@/composables/useConfig';
import useDarkMode from '@/composables/useDarkMode';
import { sleep } from '@/lib/utils';
import useWeb3 from '@/services/web3/useWeb3';

/**
 * PROPS & EMITS
 */

export default /*#__PURE__*/_defineComponent({
  emits: ['close'],
  setup(__props, { emit }) {



/**
 * COMPOSABLES
 */
const { darkMode, toggleDarkMode } = useDarkMode();
const { blockNumber } = useWeb3();
const { networkConfig } = useConfig();
const { version } = useApp();
const { t } = useI18n();
const router = useRouter();

/**
 * STATE
 */
const blockIcon = ref<HTMLDivElement>();

const navLinks = [
  { label: t('invest'), path: '/' },
  { label: t('trade'), path: '/trade' },
  { label: t('portfolio'), path: '/portfolio' },
  { label: 'veBAL', path: '/vebal' },
  { label: t('claim'), path: '/claim' },
];

const ecosystemLinks = [
  { label: t('build'), url: 'https://balancer.fi/build' },
  { label: t('blog'), url: 'https://medium.com/balancer-protocol' },
  { label: t('docs'), url: 'https://docs.balancer.fi/' },
  { label: t('governance'), url: 'https://vote.balancer.fi/#/' },
  { label: t('analytics'), url: 'https://dune.xyz/balancerlabs' },
  { label: t('forum'), url: 'https://forum.balancer.fi/' },
  {
    label: t('grants'),
    url: 'http://grants.balancer.community',
  },
];

const socialLinks = [
  { component: 'TwitterIcon', url: 'https://twitter.com/BalancerLabs' },
  { component: 'DiscordIcon', url: 'https://discord.balancer.fi/' },
  { component: 'MediumIcon', url: 'https://medium.com/balancer-protocol' },
  {
    component: 'YoutubeIcon',
    url: 'https://www.youtube.com/channel/UCBRHug6Hu3nmbxwVMt8x_Ow',
  },
  { component: 'GithubIcon', url: 'https://github.com/balancer-labs/' },
];

/**
 * METHODS
 */
async function navTo(path: string) {
  router.push(path);
  emit('close');
}

/**
 * WATCHERS
 */
watch(blockNumber, async () => {
  blockIcon.value?.classList.add('block-change');
  await sleep(300);
  blockIcon.value?.classList.remove('block-change');
});

return (_ctx: any,_cache: any) => {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalLink = _resolveComponent("BalLink")!
  const _component_MoonIcon = _resolveComponent("MoonIcon")!
  const _component_SunIcon = _resolveComponent("SunIcon")!
  const _component_EmailIcon = _resolveComponent("EmailIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppLogo, { forceDark: "" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navLinks, (link) => {
        return _createElementVNode("div", {
          key: link.label,
          class: "side-bar-link",
          onClick: ($event: any) => (navTo(link.path))
        }, _toDisplayString(link.label), 9, _hoisted_4)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ecosystemLinks, (link) => {
        return _createVNode(_component_BalLink, {
          key: link.url,
          href: link.url,
          class: "flex items-center side-bar-link",
          external: "",
          noStyle: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(link.label) + " ", 1),
            _createVNode(_component_BalIcon, {
              name: "arrow-up-right",
              size: "sm",
              class: "ml-1 text-secondary"
            })
          ]),
          _: 2
        }, 1032, ["href"])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: "mt-2 side-bar-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggleDarkMode) && _unref(toggleDarkMode)(...args)))
      }, [
        (!_unref(darkMode))
          ? (_openBlock(), _createBlock(_component_MoonIcon, {
              key: 0,
              class: "mr-2"
            }))
          : (_openBlock(), _createBlock(_component_SunIcon, {
              key: 1,
              class: "mr-2"
            })),
        _createElementVNode("span", null, _toDisplayString(_unref(darkMode) ? 'Light' : 'Dark') + " mode", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socialLinks, (link) => {
        return _createVNode(_component_BalLink, {
          key: link.component,
          href: link.url,
          class: "social-link",
          noStyle: "",
          external: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(link.component)))
          ]),
          _: 2
        }, 1032, ["href"])
      }), 64)),
      _createVNode(_component_BalLink, {
        href: "mailto:contact@balancer.finance",
        class: "social-link",
        noStyle: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_EmailIcon)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", {
          ref: (_value, _refs) => {
            _refs['blockIcon'] = _value
            blockIcon.value = _value
          },
          class: "w-2 h-2 bg-green-500 rounded-full block-icon"
        }, null, 512),
        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(networkConfig).name) + ": Block " + _toDisplayString(_unref(blockNumber)), 1)
      ]),
      _createVNode(_component_BalLink, {
        href: `https://github.com/balancer-labs/frontend-v2/releases/tag/${_unref(version)}`,
        class: "flex items-center mt-2 text-gray-300",
        external: "",
        noStyle: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(" App: v" + _toDisplayString(_unref(version)) + " ", 1),
          _createVNode(_component_BalIcon, {
            name: "arrow-up-right",
            size: "xs",
            class: "ml-1"
          })
        ]),
        _: 1
      }, 8, ["href"])
    ])
  ]))
}
}

})